export default {
    common: {
        logout: "Logout",
        profile: "Profile",
        register: "Sign Up",
        login: "Log In",

        login_guide: {
            login_now: "Log In Now",
            not_login: "Not logged in",
            sub_text: "Please log in to access more features",
        },

        vip_expire: "Expired At: {date}",
    },
};
